import Marquee from "react-fast-marquee";
import { useState, useEffect } from "react";

export const SloganMarquee = ({ dark = false }) => {
  const words = ["Voir clair.", "Décider juste.", "Développer durablement."];
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduceMotion(mq.matches);
    const onChange = (e) => setReduceMotion(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <div
      data-testid="slogan-marquee"
      aria-label="Voir clair. Décider juste. Développer durablement."
      className={`border-y py-6 md:py-8 ${
        dark ? "border-[#C8A97E]/20 bg-[#0B2215] text-[#F9F8F6]" : "border-[#0B2215]/10 bg-[#F9F8F6] text-[#0B2215]"
      }`}
    >
      <Marquee speed={28} gradient={false} autoFill play={!reduceMotion}>
        {words.map((w, i) => (
          <span key={i} className="mx-10 flex items-center gap-20 md:mx-16">
            <span className="font-serif-display text-2xl italic md:text-4xl">{w}</span>
            <span className="text-[#C8A97E]" aria-hidden="true">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
